import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTickCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={15} height={14} fill='none' {...props}>
    <path
      stroke='#089981'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M7.8 12.833c3.208 0 5.833-2.625 5.833-5.833S11.008 1.167 7.8 1.167 1.967 3.792 1.967 7s2.625 5.833 5.833 5.833'
    />
    <path
      stroke='#089981'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='m5.32 7 1.652 1.65 3.307-3.3'
    />
  </svg>
);
export default SvgTickCircle;
